module.exports = __webpack_public_path__ + "img/rise-1@3x.c21b5f95.png";